export const select = {
    slots: {
        placeholder: 'text-muted',
    },
    variants: {
        size: {
            md: {
                base: 'p-3.5',
            },
        },
    },
}
